<script setup>
import { useTheme } from 'vuetify'
const theme = useTheme()

const toggleTheme = () => {
  theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark'
  localStorage.setItem("__themeMode", theme.global.current.value.dark ? 'dark' : 'light');
}

</script>

<template>
  <v-btn class="__btn_bg" @click="toggleTheme()" :icon="theme.global.current.value.dark ? 'mdi-moon-waxing-crescent' : 'mdi-weather-sunny'" ></v-btn>
</template>